// extracted by mini-css-extract-plugin
module.exports = {"main":"slider_main__zdPkw","action":"slider_action__l9aJO","scroll":"slider_scroll__wQUaZ","item":"slider_item__PaYGr","empty":"slider_empty__699O_","inner":"slider_inner__U83v8"};